
export default {
  props: {
    surtitle: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    myArguments: {
      type: Array,
      default: () => {
        return [];
      },
    },
    alternative: {
      type: Boolean,
      default: false,
    },
  },
};
